import { useFlags } from 'launchdarkly-react-client-sdk';
import type FeatureFlags from './featureFlags';
import { featureFlags } from './featureFlags';

const useFeatureFlags = () => {
  const { ...flags } = useFlags();

  const filteredFlags = Object.keys(featureFlags).filter((key) => key in flags);

  return filteredFlags.reduce((acc, key) => {
    // @ts-ignore
    acc[key] = flags[key];

    return acc;
  }, {} as FeatureFlags);
};

export default useFeatureFlags;
